import React from 'react';

export function getUsersListColumn(handleOnAssignClient){
    const column = [

        {
            dataField: 'rcmUserId',
            text: 'User Email',
            headerClasses: 'RCM_noWrap RCM_clientName_col',
            classes: 'RCM_common_table_column_text',
            headerAlign: 'left',
            sort: true,
            sortCaret: (order, column) => customCaretSort(order, column),
            formatter: (cell, row) => {
                return(<div style={{cursor:'pointer'}} title={cell}>
                        {cell}
                    </div>);
            }
        },
        {
            dataField: 'firstname',
            text: 'First Name',
            headerClasses: 'RCM_noWrap',
            //classes: 'RCM_common_table_column_text RCM_common_table_column_text_right',
            classes: 'RCM_common_table_column_text',
            headerAlign: 'left',
            sort: true,
            sortCaret: (order, column) => customCaretSort(order, column)
        },
        {
            dataField: 'lastname',
            text: 'Last Name',
            headerClasses: 'RCM_noWrap',
            classes: 'RCM_common_table_column_text',
            headerAlign: 'left',
            sort: true,
            sortCaret: (order, column) => customCaretSort(order, column)
        },
        {
            dataField: '',
            text: '',
            sort: false,
            isDummyField: true,
            headerAlign: 'right',
            formatter: (cell, row) => {
                    return(<div align="right">
                            <button type="button" className="RCM_billpay_btn" onClick={() => handleOnAssignClient(row)} >ASSIGN CLIENT</button>
                        </div>);
            }
        }
    ]

    return column;
}
function customCaretSort(order, column) {
    if (!order) return (<span className="RCM_Sort_arrow_icon"></span>);
    else if (order === 'asc') return (<span className="RCM_Sort_arrow_down_icon"></span>);
    else if (order === 'desc') return (<span className="RCM_Sort_arrow_up_icon"></span>);
    return null;
}
